import { Space, Button, Row, Col, Descriptions, Table } from 'antd';
import { EditFilled } from '@ant-design/icons';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import './Users.css';
import { useGetVehicle } from "../../../../hooks/useGetAdmin";
import { hexToSteamId64 } from '../../../../utils/steam';
import InventoryItem from './components/InventoryItem';
import CharacterDivider from './components/CharacterDivider';
import { useQuery, gql } from '@apollo/client';

const GET_VEHICLE = gql`
  query GetVehicle($plate: String!) {
    vehicle(plate: $plate) {
      id
      plate
      vehicle
      license
      citizenid
      hash
      garage
      drivingdistance
      supporter
      glovebox
      trunk
      evidence
      status
      damage
      mods
      paymentsleft
      balance
      paymentamount
      financetime
      fuel
      engine
      body
      state
      hasnitro
      noslevel
    }
  }
`;

function EditData({ type }) {
  return (
    <Button shape="circle" icon={<EditFilled />} onClick={() => console.log(type)} />
  );
}

function App() {
  const { id } = useParams();

  // const { data, isError, isFetching } = useGetVehicle(id);
  const { data, error: isError, loading: isFetching } = useQuery(GET_VEHICLE, {
    variables: { plate: id }
  });

  const [vehicle, setVehicleData] = useState([]);

  useEffect(() => {
    if (!isFetching && data) {
      if (data.vehicle) {
        const vehicle = data.vehicle;
        const glovebox = JSON.parse(vehicle.glovebox);
        const trunk = JSON.parse(vehicle.trunk);
        const evidence = JSON.parse(vehicle.evidence);
        const status = JSON.parse(vehicle.status);
        const damage = JSON.parse(vehicle.damage);
        const mods = JSON.parse(vehicle.mods);

        const fixedData = {
          ...vehicle,
          glovebox,
          trunk,
          evidence,
          status,
          damage,
          mods,
        }

        setVehicleData(fixedData);
      }
    }
  }, [data, isFetching]);

  if (isError) {
    return (
      <div>
        <h1>Error fetching character.</h1>
        <p>{isError.message}</p>
      </div>
    );
  }

  if (isFetching) {
    return (
      <div>
        <h1>Loading...</h1>
      </div>
    );
  }

  return (
    <Space size="large" direction="vertical" style={{ width: '100%', marginBottom: '24px' }}>
      <h1>View vehicle</h1>
      <Row gutter={5}>
        <Col span={24}>
          <Descriptions extra={<EditData type="vehicle_basics" />} labelStyle={{ fontWeight: 'bold' }} column={{ xs: 1, sm: 1, md: 1, lg: 2, xl: 4, xxl: 4 }} layout="vertical" size="small" bordered title="Vehicle Details">
            <Descriptions.Item label="Model">{vehicle.vehicle}</Descriptions.Item>
            <Descriptions.Item label="Model Hash">{vehicle.hash}</Descriptions.Item>
            <Descriptions.Item label="Owner CID">{vehicle.citizenid}</Descriptions.Item>
            <Descriptions.Item label="Owner License">{vehicle.license}</Descriptions.Item>
            <Descriptions.Item label="Owner Steam ID 64">{hexToSteamId64(vehicle.license)}</Descriptions.Item>
            <Descriptions.Item label="Supporter">{vehicle.supporter}</Descriptions.Item>
            <Descriptions.Item label="Garage">{vehicle.garage}</Descriptions.Item>
          </Descriptions>
        </Col>
      </Row>

      <CharacterDivider />

      <Row gutter={5}>
        <Col span={24}>
          <Descriptions extra={<EditData type="vehicle_status" />} labelStyle={{ fontWeight: 'bold' }} column={{ xs: 1, sm: 1, md: 1, lg: 2, xl: 4, xxl: 4 }} layout="vertical" size="small" bordered title="Status">
            <Descriptions.Item label="Mileage">{vehicle.drivingdistance || 0}</Descriptions.Item>
            <Descriptions.Item label="Engine">{vehicle.engine}</Descriptions.Item>
            <Descriptions.Item label="Body">{vehicle.body}</Descriptions.Item>
            <Descriptions.Item label="Fuel">{vehicle.fuel}</Descriptions.Item>
            <Descriptions.Item label="State">{vehicle.state}</Descriptions.Item>
            <Descriptions.Item label="Ntirous">{vehicle.hasnitro ? vehicle.noslevel : "N/a"}</Descriptions.Item>
          </Descriptions>
        </Col>
      </Row>


      {vehicle?.paymentsleft > 0 && (
        <>
          <CharacterDivider />

          <Row gutter={5}>
            <Col span={24}>
              <Descriptions extra={<EditData type="vehicle_finance" />} labelStyle={{ fontWeight: 'bold' }} column={{ xs: 1, sm: 1, md: 1, lg: 2, xl: 4, xxl: 4 }} layout="vertical" size="small" bordered title="Finance">
                <Descriptions.Item label="Balance">{vehicle.balance || 0}</Descriptions.Item>
                <Descriptions.Item label="Payment Amount">{vehicle.paymentamount}</Descriptions.Item>
                <Descriptions.Item label="Payments Left">{vehicle.paymentsleft}</Descriptions.Item>
                <Descriptions.Item label="Finance Time">{vehicle.financetime}</Descriptions.Item>
              </Descriptions>
            </Col>
          </Row>
        </>
      )}

      <CharacterDivider />

      <Row gutter={[{ xs: 5, sm: 5, md: 5, lg: 5 }, { xs: 5, sm: 5, md: 5, lg: 5 }]}>
        <Col span={24}>
          <Descriptions extra={<EditData type="glovebox" />} labelStyle={{ fontWeight: 'bold' }} layout="vertical" size="small" title="Glovebox">
            {!vehicle.glovebox && (
              <Descriptions.Item label="">
                No items in the glovebox.
              </Descriptions.Item>
            )}
          </Descriptions>
        </Col>
        {vehicle.glovebox && (
          vehicle?.glovebox?.map((item, index) => (
            <Col key={index}>
              <InventoryItem item={item.name} amount={item.count} />
            </Col>
          ))
        )}
      </Row>

      <CharacterDivider />

      <Row gutter={[{ xs: 5, sm: 5, md: 5, lg: 5 }, { xs: 5, sm: 5, md: 5, lg: 5 }]}>
        <Col span={24}>
          <Descriptions extra={<EditData type="trunk" />} labelStyle={{ fontWeight: 'bold' }} layout="vertical" size="small" title="Trunk">
            {!vehicle.trunk && (
              <Descriptions.Item label="">
                No items in the trunk.
              </Descriptions.Item>
            )}
          </Descriptions>
        </Col>
        {vehicle.trunk && (
          vehicle?.trunk?.map((item, index) => (
            <Col key={index}>
              <InventoryItem item={item.name} amount={item.count} />
            </Col>
          ))
        )}
      </Row>

      <CharacterDivider />

      <Row gutter={5}>
        <Col span={24}>
          <Descriptions extra={<EditData type="vehicle_mods" />} labelStyle={{ fontWeight: 'bold' }} column={{ xs: 1, sm: 1, md: 1, lg: 2, xl: 4, xxl: 4 }} layout="vertical" size="small" bordered title="Mods">
            {vehicle?.mods && Object.keys(vehicle?.mods).map((key, index) => {
              let value = vehicle?.mods[key];

              if (typeof value === "boolean") {
                value = value ? "Yes" : "No";
              } else if (typeof value === "number") {
                if (value === -1) {
                  value = "N/a";
                }
              } else if (typeof value === "object") {
                value = JSON.stringify(value);
              }

              return (
                <Descriptions.Item key={index} label={key}>{value}</Descriptions.Item>
              )
            })}
          </Descriptions>
        </Col>
      </Row>

      <CharacterDivider />

      <Row gutter={5}>
        <Col span={24}>
          <Descriptions extra={<EditData type="vehicle_evidence" />} labelStyle={{ fontWeight: 'bold' }} column={{ xs: 1, sm: 1, md: 1, lg: 2, xl: 4, xxl: 4 }} layout="vertical" size="small" bordered title="Evidence">
            {vehicle?.evidence && vehicle?.evidence.map((item, index) => {
              const evidenceType = item.evtype || "Unknown";
              const evidenceFingerprint = item.fingerprint || "Unknown";
              const evidenceLocation = item.location || "Unknown";
              const evidenceTime = item.time * 1000 || "Unknown";

              let time = evidenceTime;

              if (time !== "Unknown") {
                time = new Date(time).toLocaleString();
              }

              return (
                <>
                  <Descriptions.Item label={"Type"}>{evidenceType}</Descriptions.Item>
                  <Descriptions.Item label={"Fingerprint"}>{evidenceFingerprint}</Descriptions.Item>
                  <Descriptions.Item label={"Location"}>{evidenceLocation}</Descriptions.Item>
                  <Descriptions.Item label={"Time"}>{time}</Descriptions.Item>
                </>
              )
            })}
          </Descriptions>
        </Col>
      </Row>

      <CharacterDivider />

      <Row gutter={5}>
        <Col span={24}>
          <Descriptions extra={<EditData type="vehicle_damage" />} labelStyle={{ fontWeight: 'bold' }} column={{ xs: 1, sm: 1, md: 1, lg: 2, xl: 4, xxl: 4 }} layout="vertical" size="small" bordered title="Damage">
            {vehicle?.damage && Object.keys(vehicle?.damage).map((key, index) => {
              let value = vehicle?.damage[key];

              if (typeof value === "boolean") {
                value = value ? "Yes" : "No";
              } else if (typeof value === "number") {
                if (value === -1) {
                  value = "N/a";
                }
              } else if (typeof value === "object") {
                value = JSON.stringify(value);
              }

              return (
                <Descriptions.Item key={index} label={key}>{value}</Descriptions.Item>
              )
            })}
          </Descriptions>
        </Col>
      </Row>

      <CharacterDivider />

      <Row gutter={5}>
        <Col span={24}>
          <Descriptions extra={<EditData type="vehicle_status" />} labelStyle={{ fontWeight: 'bold' }} column={{ xs: 1, sm: 1, md: 1, lg: 2, xl: 4, xxl: 4 }} layout="vertical" size="small" bordered title="Status">
            {vehicle?.status && Object.keys(vehicle?.status).map((key, index) => {
              let value = vehicle?.status[key];

              if (typeof value === "boolean") {
                value = value ? "Yes" : "No";
              } else if (typeof value === "number") {
                if (value === -1) {
                  value = "N/a";
                }
              } else if (typeof value === "object") {
                value = JSON.stringify(value);
              }

              return (
                <Descriptions.Item key={index} label={key}>{value}</Descriptions.Item>
              )
            })}
          </Descriptions>
        </Col>
      </Row>

      {/* <pre>
        {JSON.stringify(vehicle, null, 2)}
      </pre> */}
    </Space >
  );
}

export default App;
